// @flow

import React from "react";
import { localize } from "redux-i18n";
import { format } from "date-fns";
import { ColumnsContainer, View, Text } from "@components";
import type { EmployeeType } from "@modules/employee/types";
import { formatDate } from "@transformers/date";

type Props = $Exact<{
  employee: EmployeeType,
  title?: string,
  ...PropsFromLocalize,
}>;

export class ExportPersonalDetails extends React.Component<Props> {
  static defaultProps = {
    title: "",
  };

  get personalDetails() {
    return [
      {
        columns: [
          {
            columnTitle: this.props.t("PERSONAL_DETAILS"),
            data: [
              [
                this.props.t("COMPANY"),
                (this.props.employee.client || {}).name || this.props.t("N/A"),
              ],
              [this.props.t("FIRST_NAME"), this.props.employee.firstName || this.props.t("N/A")],
              [this.props.t("SURNAME"), this.props.employee.lastName || this.props.t("N/A")],
              [this.props.t("GENDER"), this.props.t(this.props.employee.gender || "N/A")],
              [
                this.props.t("DATE_OF_BIRTH"),

                this.props.employee.dateOfBirth
                  ? format(this.props.employee.dateOfBirth, "DD/MM/YYYY")
                  : this.props.t("N/A"),
              ],
            ],
          },
          {
            columnTitle: this.props.t("EMPLOYEMENT_INFO"),
            data: [
              [
                this.props.t("EMPLOYEE_REF"),
                this.props.employee.employeeRefPrimary || this.props.t("N/A"),
              ],
              [
                this.props.t("EMPLOYMENT_TYPE"),
                this.props.employee.employmentType.name || this.props.t("N/A"),
              ],
              [
                this.props.t("EMPLOYMENT_START_DATE"),
                formatDate(this.props.employee.joinDate || this.props.t("N/A")),
              ],
              [
                this.props.t("EMPLOYMENT_END_DATE"),
                formatDate(this.props.employee.leaveDate || this.props.t("N/A")),
              ],
            ],
          },
          {
            columnTitle: this.props.t("CONTACT_INFO"),
            data: [
              [
                this.props.t("WORK_PHONE"),
                this.props.employee.contactDetails.notificationMobile || this.props.t("N/A"),
              ],
              [
                this.props.t("PRIMARY_EMAIL_ADDRESS"),
                this.props.employee.contactDetails.workEmail || this.props.t("N/A"),
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    if (!this.props.employee) {
      return null;
    }

    return (
      <View>
        <Text type="h5" text={this.props.t("PERSONAL_DETAILS")} />
        <ColumnsContainer className="w-100" title={this.props.title} rows={this.personalDetails} />
      </View>
    );
  }
}

export default localize()(ExportPersonalDetails);
